<form [formGroup]="form" class="example-form">
    <mat-form-field appearance="outline" class="matFormField" width="100%">
      <mat-label class="mat-label-background">{{field.label}}</mat-label>
      <input [type]="field.controlType" [placeholder]="field.label" [attr.arialabel]="field.label" matInput [formControlName]="field.control" onlyNumbers />
    </mat-form-field>
    <div *ngIf="field.helperText" class="helper-text">{{field.helperText}}</div>
</form>